import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pix-component',
  templateUrl: './pix-component.component.html',
  styleUrls: ['./pix-component.component.scss']
})
export class PixComponentComponent implements OnInit {

  @Input() transaction: object;
  @Input() plan: object;

  constructor(
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
  }

  formatDate (dateInput) {
    return moment(dateInput).format('DD/MM/YYYY')
  }

  copyCode(code: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
		this.toastr.success('Código pix copiado!');
  }

  voltar () {
    window.history.back()
  }

}
